import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=2cfd266e&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=js"
export * from "./todoList.vue?vue&type=script&lang=js"
import style0 from "./todoList.vue?vue&type=style&index=0&id=2cfd266e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd266e",
  null
  
)

export default component.exports